import React from "react";
import PropTypes from "prop-types";
//import material-ui components
import withStyles from "@material-ui/core/styles/withStyles"
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
//import material icons
import Close from "@material-ui/icons/Close";
//import core components
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput";

import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

class EditMachineLimitDialog extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            uv_lamp_max_hours: "",
            filter_max_liters: "",
            ozone_max_hours: "",
            pump_max_hours: "",
        };
    }

    componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.machineData && !this.state.uv_lamp_max_hours){
            this.setState({
                uv_lamp_max_hours: ~~(nextProps.machineData.uv_lamp_max_seconds / 3600),
                filter_max_liters: nextProps.machineData.filter_max_liters,
                ozone_max_hours: ~~(nextProps.machineData.ozone_max_seconds / 3600),
                pump_max_hours: ~~(nextProps.machineData.pump_max_seconds / 3600)
            })
        }
        if (!nextProps.isOpened) {
            this.setState({
                uv_lamp_max_hours: "",
                filter_max_liters: "",
                ozone_max_hours: "",
                pump_max_hours: "",
            })
        }
    }

    _changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state)
    }

    render(){
        const { classes, onCancel, onSave, isOpened } = this.props;
        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                open={isOpened}
                onClose={() => onCancel()}
            >
                <DialogTitle
                    disableTypography
                    className={classes.modalHeader}
                >
                    <IconButton
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={() => onCancel()}
                    >
                        <Close className={classes.modalClose} />
                    </IconButton>
                    <h4 className={classes.modalTitle} >Изменение лимитов работы узлов</h4>
                </DialogTitle>
                <DialogContent className={classes.modalBody}>
                    <Grid container>
                        <GridItem xs={12}>
                            <CustomInput
                                labelText="Лимит УФ лампы, ч"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.uv_lamp_max_hours,
                                    onChange: e => this._changeValue(e, "uv_lamp_max_hours")
                                }}
                            />
                            <CustomInput
                                labelText="Лимит фильтра, л."
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.filter_max_liters,
                                    onChange: e => this._changeValue(e, "filter_max_liters")
                                }}
                            />
                            <CustomInput
                                labelText="Лимит озонатора, ч."
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.ozone_max_hours,
                                    onChange: e => this._changeValue(e, "ozone_max_hours")
                                }}
                            />
                            <CustomInput
                                labelText="Лимит насоса, ч."
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.pump_max_hours,
                                    onChange: e => this._changeValue(e, "pump_max_hours")
                                }}
                            />
                        </GridItem>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.modalFooter} >
                    <Button color="primary"
                            onClick={() => onSave({
                                uv_lamp_max_seconds: this.state.uv_lamp_max_hours * 3600,
                                pump_max_hours: this.state.pump_max_hours * 3600,
                                ozone_max_seconds: this.state.ozone_max_hours * 3600,
                                filter_max_liters: this.state.filter_max_liters,
                            })}
                    >
                        Сохранить
                    </Button>
                    <Button color="primary" simple
                            onClick={() => onCancel()}
                    >
                        Отменить
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

EditMachineLimitDialog.propTypes = {
    isOpened: PropTypes.bool,
    machineData: PropTypes.object,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
};

export default withStyles(modalStyle)(EditMachineLimitDialog);


// WEBPACK FOOTER //
// ./src/components/Dialogs/EditMachineLimitsDialog.jsx